import React from "react";
import { connect } from "react-redux";
import QRCode from "qrcode.react";
import { Field, reduxForm, change } from "redux-form";

import "./Account.css"

import history from "../../../../history";
import { SET_SELECTED_USER } from "../../../../actions/types";
import { getUser, updateUserPassword, updateUserPin, startActivation, toggleUserLeave, toggleUserLocked, resetUserPass } from "../../../../actions/userActions";
import { getAccessCode, getGuestAccessCodes, newAccessCode, invalidateAccessCode } from "../../../../actions/accessCodeActions";

import Form from "../../../CustomViews/Form";
import Modal from "../../../CustomViews/Modal";

const PasswordForm = reduxForm({ form: "passwordForm" })(Form);
const PinForm = reduxForm({ form: "pinForm" })(Form);
const QRForm = reduxForm({ form: "qrForm" })(Form);

class Account extends React.Component {
    constructor(props) {
        super(props);

        this.modalMessage = React.createRef();
        this.modalErrors = { "message": React.createRef() };

        this.state = {
            passwordForm: false,
            pinForm: false,
            qrCode: false,
            modal: false,
            modalType: "",
            modalAction: null,
            render: false,
            accessCode: false
        };
    }

    componentDidMount() {
        if (this.props.user === "selected") {
            this.props.getUser(this.props.match.params.userID, SET_SELECTED_USER);
            if (+this.props.match.params.userID === +process.env.REACT_APP_GUEST_USER_ID) this.props.getGuestAccessCodes();

        } else {
            this.props.getAccessCode();
            this.setState({ render: true, accessCode: true });
        }
    }

    componentDidUpdate() {
        if (!this.state.render && this.props.user === "selected" && this.props.currentUser.userID && this.props.selectedUser.userID) {
            if (this.props.selectedUser.userID === this.props.currentUser.userID) history.push("/account");
            else this.setState({ render: true });

        } else if (!this.state.render && this.props.user !== "selected") this.setState({ render: true });
        if (this.props.user !== "selected" && !this.state.accessCode) {
            this.props.getAccessCode();
            this.setState({ accessCode: true });
        }

        document.activeElement.blur();
    }

    renderForm = (FormComponent, initialValues, onSubmit, label, action, fields) => {
        return (
            <FormComponent initialValues={initialValues} onSubmit={onSubmit} label={label} action={action} fields={fields} renderFields={this.renderFields} />
        );
    };

    renderFields = (fields, label, action, renderInput, formErrors, renderError) => {
        return (
            <table>
                <tbody>
                    {fields.map((field, index) => {
                        if (field.name) {
                            return field.button ? (
                                this.renderRow(false, index, field.label, "", "data input high button", label, action, field, renderInput, formErrors, renderError)
                            ) : (
                                this.renderRow(false, index, field.label, "", "two data input", "", null, field, renderInput, formErrors, renderError)
                            );
                        }
                        else return this.renderRow(false, index, field.header, field.value, field.type)
                    })}
                </tbody>
            </table>
        );
    };

    renderRow = (selected, key, header, value, type, button = "", action = null, field = null, renderInput = null, formErrors = null, renderError = null) => {
        let error;
        if (type.includes("input")) error = formErrors.filter(err => err.field === field.name)[0];

        return (
            <tr key={key}>
                <td className={type === "divider" ? "" : "header"} colSpan={type === "divider" ? "2" : "1"}>
                    {type === "divider" ? <div className="ui horizontal divider">{value}</div> : header}
                </td>
                {type !== "divider" ? (
                    <td className={type.includes("red") ? "locked" : ""}>
                        {type.includes("input") ? (
                            <div className="field">
                                <Field type={field.type} name={field.name} component={(input) => renderInput(input, field.autofocus)} placeholder={field.placeholder} />
                                {renderError(error)}
                            </div>
                        ) : value}
                    </td>
                ) : null}
                {(type !== "divider" && !type.includes("two") && !selected) ? (
                    <td className={type.includes("no border") ? "no-border" : ""} rowSpan={type.includes("high") ? "2" : "1"}>
                        {type.includes("button") ? <button className="ui button" type={type.includes("input") ? "" : "button"} onClick={action}>{button}</button> : null}
                    </td>
                ) : null}
            </tr>
        );
    };

    renderSubUnits = user => {
        return (
            <React.Fragment>
                {user.subUnits.map((subUnit, index) =>{
                    return (
                        this.renderRow(this.props.user === "selected", `ss${index}`, index === 0 ? "Stanowisko:" : "", `${subUnit.priority === 1 ? "Przełożony" : "Zastępca przełożonego"} jednostki ${subUnit.ouName}${subUnit.dateFrom && subUnit.dateTo ? ` od ${subUnit.dateFrom} do ${subUnit.dateTo}` : ""}`, "data no border")
                    );
                })}
                {user.coordinatedUnits.map((coordinatedUnit, index) =>{
                    return (
                        this.renderRow(this.props.user === "selected", `sc${index}`, (!user.subUnits.length && index === 0) ? "Stanowisko:" : "", `Koordynator firmy zewnętrznej ${coordinatedUnit.name}`, "data no border")
                    );
                })}
            </React.Fragment>
        );
    };

    renderQRPanels = () => {
        if (this.props.user !== "selected") return (
            <React.Fragment>
                <div className="ui divider" />
                {this.renderQRPanel({
                    accessCodeID: this.props.accessCode,
                    subID: null,
                    validTo: null
                })}
            </React.Fragment>
        );
        else if (this.props.selectedUser.userID === +process.env.REACT_APP_GUEST_USER_ID) return (
            <React.Fragment>
                <div className="ui divider" />
                <div className="ui header">
                    <div className="content">Kod stały:</div>
                </div>
                {this.renderQRPanel(this.props.accessCodeList.lifetime, true)}
                <div className="ui header">
                    <div className="content">Kody czasowe:</div>
                </div>
                {this.props.accessCodeList.timed.map(accessCode => {
                    return (
                        <React.Fragment key={accessCode.subID}>
                            <b>Do dnia: {accessCode.validTo}</b>
                            {this.renderQRPanel(accessCode, true)}
                        </React.Fragment>
                    );
                })}
                <QRForm onSubmit={this.onQRSubmit} label="Nowy kod QR" fields={[
                    { name: "validTo", type: "date", label: "Data ważności", placeholder: "Wpisz datę ważności..."}
                ]} />
            </React.Fragment>
        );
    };

    renderQRPanel = (accessCode, guest = false) => {        
        return (
            <React.Fragment>
                <div className="ui three columns buttons grid">
                    <div className="column">
                        {accessCode.accessCodeID ? (
                            <button className="ui button" type="button" onClick={() => this.setState({
                                qrCode: guest ? (this.state.qrCode === accessCode.subID ? false : accessCode.subID) : !this.state.qrCode
                            })}>{this.state.qrCode === true || (guest && this.state.qrCode === accessCode.subID) ? "Ukryj kod QR" : "Pokaż kod QR"}</button>
                        ) : (
                            <button className="ui primary button" type="button" onClick={() => this.props.newAccessCode(guest)}>Wygeneruj kod QR</button>
                        )}
                    </div>
                    <div className="column">
                        {accessCode.accessCodeID && (this.state.qrCode === true || (guest && this.state.qrCode === accessCode.subID)) ? (
                            <button className="ui primary button" type="button" onClick={this.onQRCodeDownloadClick}>Pobierz kod QR</button>
                        ) : null}
                    </div>
                    <div className="column">
                        {accessCode.accessCodeID ? (
                            <button className="ui negative button" type="button" onClick={() => this.onOperationClick("invalidate", accessCode.subID)}>Unieważnij kod QR</button>
                        ) : null}
                    </div>
                </div>
                {accessCode.accessCodeID && (this.state.qrCode === true || (guest && this.state.qrCode === accessCode.subID)) ? (
                    <div className="qr content">
                        <QRCode 
                            id="access-code-qr"
                            size={256}
                            value={accessCode.accessCodeID}
                            level="H"
                            includeMargin={true}
                        />
                    </div>
                ) : null}
            </React.Fragment>
        );
    };

    renderAdminPanel = () => {
        if (this.props.currentUser.admin === 1) {
            return (
                <React.Fragment>
                    <div className="ui divider" />
                    <div className="content">
                        <button className="ui button" type="button" onClick={() => this.onOperationClick("toggleLeave")}>Zmień status urlopu</button>
                    </div>
                    {this.props.user === "selected" ? (
                        <React.Fragment>
                            <div className="content">
                                <button className="ui button" type="button" onClick={() => this.onOperationClick("toggleLocked")}>{this.props.selectedUser.locked === 1 ? "Odblokuj" : "Zablokuj"}</button>
                            </div>
                            <div className="content">
                                <button className="ui button" type="button" onClick={() => this.onOperationClick("resetPass")}>Resetuj hasło</button>
                            </div>
                        </React.Fragment>                            
                    ) : null}
                </React.Fragment>
            );
        }
    };

    renderModal = () => {
        if (this.state.modal) {
            if (this.state.modalType === "activate") {
                return (
                    <Modal
                        title="Wysłano link aktywacyjny"
                        content={<p>Na adres <b>{this.props.currentUser.email}</b> wysłany został link aktywacyjny.<br />Kliknij ten link, aby aktywować konto.</p>}
                        actions={<button onClick={() => history.go(0)} className="ui button">OK</button>}
                        onDismiss={() => history.go(0)}
                    />
                );

            } else if (this.state.modalType === "invalidate") {
                return (
                    <Modal
                        title="Unieważnienie kodu QR"
                        content={(
                            <React.Fragment>
                                <p>Czy na pewno chcesz unieważnić kod QR?</p>
                            </React.Fragment>
                        )}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.props.invalidateAccessCode(this.state.modalAction)} className="ui negative button">Unieważnij</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );
                
            } else if (this.state.modalType === "toggleLeave") {
                return (
                    <Modal
                        title="Zmiana statusu urlopu użytkownika"
                        content={(
                            <React.Fragment>
                                <p>Czy na pewno chcesz zmienić status urlopu {this.props.user === "selected" ? (
                                    <React.Fragment>użytkownika <b>{`${this.props.selectedUser.lname} ${this.props.selectedUser.fname}`}</b></React.Fragment>
                                ) : "swojego konta"}?</p>
                            </React.Fragment>
                        )}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.props.toggleUserLeave(
                                    this.props.user === "selected" ? this.props.selectedUser.userID : this.props.currentUser.userID,
                                    this.props.user === "selected" ? this.props.selectedUser.onLeave === 0 : this.props.currentUser.onLeave === 0,
                                    () => history.go(0)
                                )} className="ui primary button">Zmień status</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );

            } else if (this.state.modalType === "toggleLocked") {
                return (
                    <Modal
                        title={`${this.props.selectedUser.locked === 1 ? "Odblokowanie" : "Zablokowanie"} konta użytkownika`}
                        content={(
                            <React.Fragment>
                                <p>Czy na pewno chcesz <b>{this.props.selectedUser.locked === 1 ? "odblokować" : "zablokować"}</b> konto użytkownika <b>{`${this.props.selectedUser.lname} ${this.props.selectedUser.fname}`}</b>?</p>
                                <p><input ref={this.modalMessage} placeholder="Wiadomość informacyjna (zostanie wysłana użytkownikowi)" /></p>
                                <p ref={this.modalErrors["message"]}></p>
                            </React.Fragment>
                        )}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.onAdminOptionApprove(this.props.toggleUserLocked, () => history.go(0), this.onFieldError)} className="ui primary button">{this.props.selectedUser.locked === 1 ? "Odblokuj" : "Zablokuj"}</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );

            } else if (this.state.modalType === "resetPass") {
                return (
                    <Modal
                        title="Resetowanie hasła uzytkownika"
                        content={(
                            <React.Fragment>
                                <p>Czy na pewno chcesz <b>zresetować</b> konto użytkownika <b>{`${this.props.selectedUser.lname} ${this.props.selectedUser.fname}`}</b>?</p>
                            </React.Fragment>
                        )}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.onAdminOptionApprove(this.props.resetUserPass, () => history.go(0), null)} className="ui primary button">Resetuj</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );
            }
        }
    };

    onPasswordChangeClick = () => !this.state.passwordForm ? this.setState({
        passwordForm: true,
        pinForm: false
    }) : null;

    onPasswordSubmit = (formValues, onFormError) => this.props.updateUserPassword(formValues, error => {
        this.props.change("passwordForm", "pass", "");
        this.props.change("passwordForm", "rpass", "");
        onFormError(error);
    }, () => this.onChangeFinish(false, ""));

    onPinChangeClick = () => !this.state.pinForm ? this.setState({
        passwordForm: false,
        pinForm: true
    }) : null;

    onPinSubmit = (formValues, onFormError) => this.props.updateUserPin(formValues, error => {
        this.props.change("pinForm", "pin", "");
        this.props.change("pinForm", "rpin", "");
        onFormError(error);
    }, () => this.onChangeFinish(false, ""));

    onActivateClick = () => this.props.startActivation(() => this.onChangeFinish(true, "activate"));

    onChangeFinish = (modal, type) => this.setState({
        passwordForm: false,
        pinForm: false,
        modal: modal,
        modalType: type
    });

    onQRSubmit = (formValues, onFieldError) => this.props.newAccessCode(true, {
        validTo: formValues.validTo ? formValues.validTo : ""
    }, onFieldError);

    onQRCodeDownloadClick = () => {
        const canvas = document.getElementById("access-code-qr");
        const pngUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = "qr-code.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    onOperationClick = (type, action = null) => this.setState({
        modal: true,
        modalType: type,
        modalAction: action
    });

    onAdminOptionApprove = (action, onSuccess, onFieldError) => action(this.props.selectedUser.userID, this.modalMessage.current ? this.modalMessage.current.value : null, onSuccess, onFieldError);

    onFieldError = (error) => {
        error.data.error.forEach(e => {
            if (this.modalErrors[e.field]) {
                this.modalErrors[e.field].current.innerText = "";
                this.modalErrors[e.field].current.className = "ui error message";
                e.message.forEach(line => {
                    this.modalErrors[e.field].current.innerText += `${line} `;
                });
            }
        });
    };

    linkTo = destination => history.push(destination);

    render() {
        const user = this.props.user === "selected" ? this.props.selectedUser : this.props.currentUser;
      
        if (this.state.render) {
            return (
                <React.Fragment>
                    <div className="account-component ui container">
                        <div className="ui container">
                            <div className={`ui ${user.externalOuID !== null ? "three" : "two"} column grid`}>
                                <div className={`${this.props.currentUser.admin === 1 ? "clickable " : ""}column`} onClick={this.props.currentUser.admin === 1 ? () => this.linkTo(`/structure${user.ouID ? `/unit/${user.ouID}` : ``}`) : () => {}}>
                                    <h2 className="ui icon header">
                                        <i className="sitemap icon"></i>
                                        <div className="header">{user.ouID !== null ? user.ouName : "Nieprzypisane"}</div>
                                    </h2>
                                </div>
                                {user.externalOuID !== null ? (
                                    <div className={`${this.props.currentUser.admin === 1 ? "clickable " : ""}column`} onClick={this.props.currentUser.admin === 1 ? () => this.linkTo(`/structure/external/details/${user.externalOuID}`) : () => {}}>
                                        <h2 className="ui icon header">
                                            <i className="building icon"></i>
                                            <div className="header">{user.externalOuName}</div>
                                        </h2>
                                    </div>
                                ) : null}
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className="user circle icon"></i>
                                        <div className="header">{`${user.lname} ${user.fname}`}</div>
                                    </h2>
                                </div>
                            </div>
                            <div className="ui divider" />
                            <div className="ui header">
                                <div className="content">Informacje o koncie:</div>
                            </div>
                            <div className="ui horizontal divider" style={{ width: this.props.user === "selected" ? "100%" : "" }}>Osobiste</div>
                            <table>
                                <tbody>
                                    {this.renderRow(this.props.user === "selected", "s1", "Email:", user.email, "data")}
                                    {this.renderRow(this.props.user === "selected", "s2", "Imię:", user.fname, "data")}
                                    {this.renderRow(this.props.user === "selected", "s3", "Nazwisko:", user.lname, "data")}
                                </tbody>
                            </table>
                            {this.props.user !== "selected" ? (
                                <div className="ui horizontal divider" style={{ width: this.props.user === "selected" ? "100%" : "" }}>Zabezpieczenia</div>
                            ) : null}
                            {this.state.passwordForm ? (
                                this.renderForm(PasswordForm, {}, this.onPasswordSubmit, "Zapisz", this.onPasswordChangeClick, [
                                    { name: "pass", type: "password", label: "Hasło:", placeholder: "Wpisz hasło...", button: true, autofocus: true },
                                    { name: "rpass", type: "password", label: "Powtórz hasło:", placeholder: "Powtórz hasło...", button: false }
                                ])
                            ) : this.props.user !== "selected" ? (
                                <table>
                                    <tbody>
                                        {this.renderRow(this.props.user === "selected", "s4", "Hasło:", "* * * * * * * *", "data button", "Zmień", this.onPasswordChangeClick)} 
                                    </tbody>
                                </table>
                            ) : null}
                            {this.state.pinForm ? (
                                this.renderForm(PinForm, {}, this.onPinSubmit, "Zapisz", this.onPinChangeClick, [
                                    { name: "pin", type: "password", label: "Pin:", placeholder: "Wpisz pin...", button: true, autofocus: true },
                                    { name: "rpin", type: "password", label: "Powtórz pin:", placeholder: "Powtórz pin...", button: false }
                                ])
                            ) : this.props.user !== "selected" ? (
                                <table>
                                    <tbody>
                                        {this.renderRow(this.props.user === "selected", "s5", "Pin:", "* * * * * * * *", "data button", "Zmień", this.onPinChangeClick)} 
                                    </tbody>
                                </table>
                            ) : null}
                            <table>
                                <tbody>
                                    {this.renderRow(this.props.user === "selected", "s6", "", "Firma", "divider")}
                                    {this.renderRow(this.props.user === "selected", "s7", "Jednostka organizacyjna:", user.ouID !== null ? user.ouName : "Nieprzypisane", "data no border")}
                                    {user.externalOuID != null ? (
                                        this.renderRow(this.props.user === "selected", "s8", "Firma zewnętrzna:", user.externalOuName, "data no border")
                                    ) : null}
                                    {(user.isSupervisor || user.coordinatedUnits.length) ? this.renderSubUnits(user) : (
                                        this.renderRow(this.props.user === "selected", "ss1", "Stanowisko:", user.intern === 1 ? "Praktykant" : "Pracownik", "data no border")
                                    )}
                                    {this.renderRow(this.props.user === "selected", "s9", "Na urlopie:", user.onLeave === 1 ? "Tak" : "Nie", "data no border")}
                                    {this.renderRow(this.props.user === "selected", "s10", "", "Typ konta", "divider")}
                                    {this.renderRow(this.props.user === "selected", "s11", "Typ konta:", user.admin === 1 ? "Administrator" : "Standardowe", "data no border")}
                                    {this.renderRow(this.props.user === "selected", "s12", "", "Status konta", "divider")}
                                    {user.locked === 1 ? (
                                        this.renderRow(this.props.user === "selected", "s13", "", "Zablokowane", "red data no border")
                                    ) : user.active === 1 ? (
                                        this.renderRow(this.props.user === "selected", "s13", "", "Aktywne", "data no border")
                                    ) : (
                                        this.renderRow(this.props.user === "selected", "s13", "", "Nieaktywne", "data button", "Aktywuj", this.onActivateClick)
                                    )}
                                </tbody>
                            </table>
                            {this.renderQRPanels()}
                            {this.renderAdminPanel()}
                        </div>
                    </div>
                    {this.renderModal()}
                </React.Fragment>
            );
        }
        else return null;
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    selectedUser: state.user.selected,
    accessCode: state.accessCode.accessCode,
    accessCodeList: state.accessCode.list
});

export default connect(mapStateToProps, { change, getUser, updateUserPassword, updateUserPin, startActivation, toggleUserLeave, toggleUserLocked, resetUserPass, getAccessCode, getGuestAccessCodes, newAccessCode, invalidateAccessCode })(Account);